import React from "react";
import {
    Box,
    Card,
    CardContent,
    Typography,
    Skeleton
} from "@mui/material";
import {
    Campaign as CampaignIcon,
    TrendingUp as TrendingUpIcon,
    People as PeopleIcon,
    Inventory as InventoryIcon
} from "@mui/icons-material";

export default function CampaignStats({ campaigns, metricsData, metricsLoading }) {
    const stats = [
        {
            title: "Total de Campanhas",
            value: metricsData?.total_campaigns || 0,
            icon: CampaignIcon,
            color: "#ff9800"
        },
        {
            title: "Campanhas Ativas",
            value: metricsData?.active_campaigns || 0,
            icon: TrendingUpIcon,
            color: "#4caf50"
        },
        {
            title: "Campanhas Pendentes",
            value: metricsData?.pending_campaigns || 0,
            icon: PeopleIcon,
            color: "#ff9800"
        },
        {
            title: "Campanhas Finalizadas",
            value: metricsData?.finished_campaigns || 0,
            icon: InventoryIcon,
            color: "#757575"
        }
    ];

    return (
        <Box sx={{ 
            display: 'flex',
            gap: 3,
            mb: 3,
            flexWrap: 'wrap'
        }}>
            {stats.map((stat, index) => {
                const IconComponent = stat.icon;
                return (
                    <Box 
                        key={index}
                        sx={{ 
                            flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 12px)', md: '1 1 calc(25% - 18px)' },
                            minWidth: '200px'
                        }}
                    >
                        <Card sx={{
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                            borderRadius: 2,
                            transition: 'transform 0.2s ease-in-out',
                            '&:hover': {
                                transform: 'translateY(-2px)',
                                boxShadow: '0 4px 16px rgba(0,0,0,0.15)'
                            }
                        }}>
                            <CardContent sx={{ p: 3 }}>
                                <Box sx={{ 
                                    display: 'flex', 
                                    alignItems: 'center', 
                                    gap: 2 
                                }}>
                                    <Box sx={{
                                        p: 1.5,
                                        borderRadius: 2,
                                        bgcolor: `${stat.color}15`,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <IconComponent 
                                            sx={{ 
                                                color: stat.color,
                                                fontSize: 32
                                            }} 
                                        />
                                    </Box>
                                    <Box sx={{ flex: 1 }}>
                                        {metricsLoading ? (
                                            <Skeleton variant="text" width={80} height={48} />
                                        ) : (
                                            <Typography 
                                                variant="h4" 
                                                component="div"
                                                sx={{
                                                    fontWeight: 700,
                                                    color: 'grey.800',
                                                    fontSize: '2rem'
                                                }}
                                            >
                                                {stat.value.toLocaleString('pt-BR')}
                                            </Typography>
                                        )}
                                        <Typography 
                                            color="text.secondary"
                                            sx={{
                                                fontWeight: 500,
                                                fontSize: '0.875rem'
                                            }}
                                        >
                                            {stat.title}
                                        </Typography>
                                    </Box>
                                </Box>
                            </CardContent>
                        </Card>
                    </Box>
                );
            })}
        </Box>
    );
}
